export default __webpack_public_path__ + "static/media/Directors' Certificate to Mr Rolando M Berin (GenSan branch).abc421ad.pdf";